export default "__VITE_PUBLIC_ASSET__a06b89c4__"